
import { getApiBaseUrl, getApiClient } from "./serviceconfig";
import { appendQueryParams } from "../utils/listViewDateRanges";

var apiBaseUrl = getApiBaseUrl();

export async function getAllCheckIn(cookies, inputs) {
  let url = `${apiBaseUrl}/checkin/`;
  if (inputs && typeof inputs === 'object') {
    url = appendQueryParams(url, inputs);
  }
  return getApiClient(cookies).get(url)
    .then(response => response.data);
}

export async function createCheckIn(cookies, inputs) {

  return getApiClient(cookies).post(`${apiBaseUrl}/checkin/`,inputs)
  
}

export async function updateCheckIn(cookies, inputs, checkinId) {

    return getApiClient(cookies)
    .put(`${apiBaseUrl}/checkin/${checkinId}/`,inputs)
}
  
export async function getCheckInDetails(cookies, checkinId) {

  return getApiClient(cookies).get(`${apiBaseUrl}/checkin/${checkinId}/`)
  .then(response => response.data)
}

export async function getCheckInNumber(cookies, plantId,movement_type) {

  return getApiClient(cookies).get(`${apiBaseUrl}/checkout/checkout_number/?plant_id=${plantId}&movement_type=${movement_type}`)
  .then(response => response.data)
}
export async function deleteCheckIn(cookies, checkinId) {

  return getApiClient(cookies).delete(
    `${apiBaseUrl}/checkin/${checkinId}/`)
   
}

export async function printDcCheckin(cookies, checkinId) {

  return getApiClient(cookies).get(`${apiBaseUrl}/checkout/${checkinId}/print_dc/`)
              .then(response => response.data)
}

export async function getDivertWorkSchedules(cookies, plantId, checkinDate) {
  let url = `${apiBaseUrl}/checkin/divert_work_schedules/?plant_id=${plantId}`;
  if (checkinDate) {
    url += `&checkin_date=${checkinDate}`;
  }
  return getApiClient(cookies).get(url).then(response => response.data);
}

export async function getCheckInKmCorrectionList(cookies, params) {
  const url = appendQueryParams(`${apiBaseUrl}/checkin/km_correction/`, params);
  return getApiClient(cookies).get(url).then((response) => response.data);
}

export async function correctCheckInKm(cookies, payload) {
  return getApiClient(cookies)
    .post(`${apiBaseUrl}/checkin/correct_km/`, payload)
    .then((response) => response.data);
}
